const CMCC_JSBRIDGE_NAME = 'CmccJSBridge'

// 是否运行在真实的 CMCC APP 内（不含 Mock）
// 判定规则：
//   - UA 中包含 cmcc / chinamobile / 中国移动 关键字
//   - 或宿主 APP 在 window 上挂了非 Mock 的 JSBridge（由 __isMock 标记）
function isInCmccApp() {
  const ua = navigator.userAgent.toLowerCase()
  if (/cmcc|chinamobile|中国移动/.test(ua)) return true
  const bridge = window[CMCC_JSBRIDGE_NAME]
  if (bridge && !bridge.__isMock) return true
  return false
}


function callNative(method, params = {}) {
  return new Promise((resolve, reject) => {
    if (!isInCmccApp()) {
      console.warn('[CmccBridge] 不在中国移动APP环境中，使用降级模式')
      reject(new Error('NOT_IN_CMCC_APP'))
      return
    }

    const callbackId = 'cmcc_cb_' + Date.now() + '_' + Math.random().toString(36).slice(2, 8)

    window[callbackId] = function(result) {
      delete window[callbackId]
      try {
        const data = typeof result === 'string' ? JSON.parse(result) : result
        if (data.code === 0 || data.code === '0') {
          resolve(data)
        } else {
          reject(data)
        }
      } catch (e) {
        resolve(result)
      }
    }

    try {
      const bridge = window[CMCC_JSBRIDGE_NAME]
      if (bridge && typeof bridge.call === 'function') {
        bridge.call(method, JSON.stringify(params), callbackId)
      } else if (bridge && typeof bridge[method] === 'function') {
        bridge[method](JSON.stringify(params))
          .then(resolve)
          .catch(reject)
      } else {
        console.warn('[CmccBridge] JSBridge方法不可用，使用降级模式')
        reject(new Error('BRIDGE_METHOD_UNAVAILABLE'))
      }
    } catch (e) {
      delete window[callbackId]
      reject(e)
    }

    setTimeout(() => {
      if (window[callbackId]) {
        delete window[callbackId]
        reject(new Error('TIMEOUT'))
      }
    }, 15000)
  })
}

export function getCmccToken() {
  return callNative('getToken').then(data => ({
    token: data.token || data.accessToken,
    expiresIn: data.expiresIn || 7200,
    timestamp: Date.now()
  }))
}

export function getCmccUserInfo() {
  return callNative('getUserInfo').then(data => ({
    userId: data.userId || data.uid,
    mobile: data.mobile || data.phoneNumber,
    username: data.nickname || data.userName || '移动用户',
    avatar: data.avatar || data.headImgUrl || '',
    carrier: 'cmcc'
  }))
}

export function cmccLogin() {
  return callNative('login').then(data => ({
    token: data.token || data.accessToken,
    userInfo: {
      userId: data.userId || data.uid,
      mobile: data.mobile || data.phoneNumber,
      username: data.nickname || data.userName || '移动用户',
      avatar: data.avatar || data.headImgUrl || ''
    }
  }))
}

export function cmccLogout() {
  return callNative('logout').catch(() => {})
}

export function cmccShare(params) {
  return callNative('share', {
    title: params.title || '',
    desc: params.desc || '',
    imageUrl: params.imageUrl || '',
    linkUrl: params.linkUrl || window.location.href
  })
}

export function cmccPay(params) {
  return callNative('pay', {
    orderId: params.orderId,
    amount: params.amount,
    productName: params.productName,
    productDesc: params.productDesc || ''
  })
}

export function cmccOpenWebView(url) {
  return callNative('openWebView', { url })
}

export function cmccGoBack() {
  return callNative('goBack')
}

export function cmccSetTitle(title) {
  return callNative('setTitle', { title })
}

export function cmccGetDeviceInfo() {
  return callNative('getDeviceInfo').then(data => ({
    deviceId: data.deviceId || '',
    platform: data.platform || '',
    osVersion: data.osVersion || '',
    appVersion: data.appVersion || '',
    networkType: data.networkType || ''
  }))
}

export function isCmccEnvironment() {
  return isInCmccApp()
}

const MockBridge = {
  getToken: () => Promise.resolve({ token: 'mock_cmcc_token_' + Date.now(), expiresIn: 7200 }),
  getUserInfo: () => Promise.resolve({ userId: 'cmcc_mock_uid', mobile: '138****5678', username: '移动玩家_Leon', avatar: '' }),
  login: () => Promise.resolve({ token: 'mock_cmcc_token_login', userInfo: { userId: 'cmcc_mock_uid', mobile: '138****5678', username: '移动玩家_Leon', avatar: '' } }),
  logout: () => Promise.resolve({}),
  share: () => Promise.resolve({}),
  pay: () => Promise.resolve({}),
  openWebView: () => Promise.resolve({}),
  goBack: () => Promise.resolve({}),
  setTitle: () => Promise.resolve({}),
  getDeviceInfo: () => Promise.resolve({ deviceId: 'mock_device', platform: 'android', osVersion: '13', appVersion: '8.5.0' })
}

if (!isInCmccApp()) {
  window[CMCC_JSBRIDGE_NAME] = {
    __isMock: true,
    call: function(method, params, callbackId) {
      const handler = MockBridge[method]
      if (handler) {
        handler().then(result => {
          if (window[callbackId]) {
            window[callbackId]({ code: 0, ...result })
          }
        }).catch(err => {
          if (window[callbackId]) {
            window[callbackId]({ code: -1, message: err.message })
          }
        })
      } else {
        if (window[callbackId]) {
          window[callbackId]({ code: -1, message: '方法不支持: ' + method })
        }
      }
    }
  }
  console.log('[CmccBridge] Mock JSBridge 已注入（开发模式）')
}
